import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  id: string;
};

const [useDeletePortal, deletePortal] = createAsyncAction(
  "portals/delete",
  async ({ id }: Args) => {
    const res = await API.call<{ portal: string }>({
      endpoint: `portals/${id}`,
      method: "DELETE",
      data: {
        status: "deleted",
      },
    });
    return { ...res, result: res.result.portal };
  }
);
export default useDeletePortal;
export { deletePortal };
